import { sendCommand } from 'react-wot-bootstrap'
import webToClient from 'react-wot-bootstrap/lib/state/middlewares/web_to_client'


// there is no handler for set sound state in react-wot-bootstrap
export default function patchedWebToClient() {
    const realWebToClient = webToClient()

    return next => action => {
        if (action.meta && action.meta.webToClient && action.meta.webToClient.handler === 'sendSoundState') {
            const params = action.meta.webToClient.params
            const payload = {
                command: 'sound_state',
                params: {
                    state_name: params.stateName,
                    state_value: params.stateValue,
                },
            }
            sendCommand(payload)

            // clear action meta, to prevent handling in react-wot-bootstrap
            action.meta = {}
        }

        return realWebToClient(next)(action)
    }
}


// WEBPACK FOOTER //
// ./state/middlewares/web_to_client.js